export const IDAssenzo2 = '2';
